/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EvolucionValorClaveDto } from '../../models/evolucion-valor-clave-dto';

export interface AnaliticasControllerObtenerEvolucionParametro$Params {

/**
 * UUID del parámetro a obtener
 */
  uuidParametro: string;
}

export function analiticasControllerObtenerEvolucionParametro(http: HttpClient, rootUrl: string, params: AnaliticasControllerObtenerEvolucionParametro$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EvolucionValorClaveDto>>> {
  const rb = new RequestBuilder(rootUrl, analiticasControllerObtenerEvolucionParametro.PATH, 'get');
  if (params) {
    rb.path('uuidParametro', params.uuidParametro, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EvolucionValorClaveDto>>;
    })
  );
}

analiticasControllerObtenerEvolucionParametro.PATH = '/api/paciente-analiticas/obtener-evoluticon-valor-clave/{uuidParametro}';
